import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log(error.response?.data || error.message);

    return Promise.reject(error);
  },
);

export default instance;
